import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';

import { Label, LabelComp } from 'containers';

const Labels = ({
  values
}) => (
  values.map(item => (
    !(item instanceof Array) ?
      <Label
        key={uuidv4()}
        name={item.label || ''}
        invert={item.invert}
        number={item.num}
        {...item}
      /> :
      <LabelComp
        key={uuidv4()}
        labels={item}
      />
  ))
);

Labels.propTypes = {
  values: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ])).isRequired
};

export default Labels;



// WEBPACK FOOTER //
// ./src/containers/Labels/Labels.js